import React from 'react';

export default function AutoScroll({ children, className, height, scrollBehavior = 'smooth' }) {
    const [autoScroll, setAutoScroll] = React.useState(true);
    const containerElement = React.useRef(null);
    const style = {
        height,
        overflow: 'auto',
        scrollBehavior: 'auto'
    };

    // Handle mousewheel events on the scroll container.
    const onWheel = () => {
        const { current } = containerElement;

        if (current) {
            setAutoScroll(current.scrollTop + current.offsetHeight === current.scrollHeight);
        }
    };

    // Apply the scroll behavior property after the first render,
    // so that the initial render is scrolled all the way to the bottom.
    React.useEffect(() => {
        setTimeout(() => {
            const { current } = containerElement;

            if (current) {
                current.style.scrollBehavior = scrollBehavior;
            }
        }, 0);
    }, [containerElement, scrollBehavior]);

    // When the children are updated, scroll the container
    // to the bottom.
    React.useEffect(() => {
        if (!autoScroll) {
            return;
        }

        const { current } = containerElement;

        if (current) {
            current.scrollTop = current.scrollHeight;
        }
    }, [children, containerElement, autoScroll]);

    return (
        <div className={className} onWheel={onWheel} ref={containerElement} style={style}>
            {children}
        </div>
    );
}
